import script from "./trueFalse.vue?vue&type=script&setup=true&lang=js"
export * from "./trueFalse.vue?vue&type=script&setup=true&lang=js"

import "./trueFalse.vue?vue&type=style&index=0&id=126a772d&scoped=true&lang=css"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-126a772d"]])

export default __exports__